import { render } from "./SwapSensorModal.vue?vue&type=template&id=4a354328&scoped=true"
import script from "./SwapSensorModal.vue?vue&type=script&lang=js"
export * from "./SwapSensorModal.vue?vue&type=script&lang=js"

import "./SwapSensorModal.vue?vue&type=style&index=0&id=4a354328&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4a354328"]])

export default __exports__